module.exports = __webpack_public_path__ + "static/img/banner3.303a4b20.jpg";